<div class="panel-content"
    [ngClass]="classes"
    [class.with-border]="withBorder"
    [class.white-background]="whiteBackground">
    <ng-content></ng-content>
</div>
